import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/8.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Na kolację do Łukaszewskiego"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p21,
            }}
            content={
                <div>
                    <p>
                        Wychodzisz z kantoratu i widzisz, że słońce chyli się ku zachodowi. Czas poszukać karczmy Łukaszewskiego, do której Emil zaprosił cię na kolację. Mówił, że w kamienicy obok mieszkają rabini, dlatego Franciszek Łukaszewski serwuje zarówno kuchnię żydowską, jak i polską. Ruszasz do karczmy, szukając ulicy Kilińskiego.
                    </p>
                </div>
            }
        />

    );
}